export const COLORS = {
    colorPrimary: '#1777ff',
    colorBgPrimary: '#032040',
    colorPrimaryHover: '#052848',
    colorPrimaryActive: '#1e293b',

    colorSecondary: '#6874ea',
    colorGraySecondary: '#a1a8b5',


    colorInfo: '#3b82f6',
    colorSuccess: '#10b981',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',


    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f5f5f5',
    colorBgInput: '#f3f3f5',


    colorText: '#1f2937',
    colorTextSecondary: '#6b7280',
    colorTextTertiary: '#9ca3af',
    colorTextQuaternary: '#d1d5db',


    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f3f4f6',
}

export const BORDER_RADIUS = {
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    borderRadiusXS: 4,
}

export const TYPOGRAPHY_SIZES = {
    H1: '32px',
    H2: '28px',
    H3: '26px',
    H4: '24px',
    H5: '22px',
    H6: '20px',
    H7: '18px',
    BIG: '16px',
    NORMAL: '14px',
    SMALL: '12px'
}

export const TYPOGRAPHY = {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
    fontSizeXL: 20,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
}

export const SPACING = {
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    paddingXL: 32,
}

export const COMPONENT_SIZE = {
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    controlHeightXS: 24,
}

export const SHADOWS = {
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    boxShadowSecondary: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    boxShadowTertiary: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
}

export const Z_INDEX = {
    zIndexBase: 0,
    zIndexPopupBase: 1000,
}

export const OPACITY = {
    opacityLoading: 0.65,
}


export const MOTION = {
    motionDurationFast: '0.1s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
}